(function () {
  if (window.chydeeCtmTestimonialsLoaded) return;
  window.chydeeCtmTestimonialsLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 989px)');
  var visibilityObserver = null;

  function isMobileTestimonials() {
    return mobileQuery.matches;
  }

  function getSection(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-ctm-section]');
  }

  function getCard(target) {
    if (!target || !target.closest) return null;
    return target.closest('.ctm__card.has-media');
  }

  function getCards(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.ctm__card.has-media'));
  }

  function loadCardMedia(card) {
    if (!card) return;

    card.querySelectorAll('.ctm__card-media img[data-ctm-src]').forEach(function (img) {
      if (img.dataset.ctmLoaded === 'true') return;
      img.src = img.dataset.ctmSrc;
      img.dataset.ctmLoaded = 'true';
    });
  }

  function prepareCards(root) {
    getCards(root).forEach(function (card) {
      var isDuplicate = card.getAttribute('aria-hidden') === 'true';

      card.setAttribute('aria-expanded', card.classList.contains('is-expanded') ? 'true' : 'false');

      if (isDuplicate) {
        card.setAttribute('tabindex', '-1');
        card.removeAttribute('role');
        return;
      }

      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');

      if (!card.hasAttribute('aria-label')) {
        card.setAttribute('aria-label', 'Reveal all testimonial photos');
      }
    });
  }

  function setExpanded(root, expanded) {
    if (!root) return;

    root.classList.toggle('ctm--cards-expanded', expanded);

    getCards(root).forEach(function (card) {
      card.classList.toggle('is-expanded', expanded);
      card.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      if (expanded) {
        loadCardMedia(card);
      }
    });
  }

  function closeAllCards() {
    document.querySelectorAll('[data-ctm-section]').forEach(function (root) {
      setExpanded(root, false);
    });
  }

  function applySectionVisibility(root) {
    if (!root) return;
    root.classList.toggle('ctm--in-view', root.dataset.ctmInViewport === 'true' && !document.hidden);
  }

  function observeSectionVisibility(root) {
    if (!root || root.dataset.ctmVisibilityObserved === 'true') return;
    root.dataset.ctmVisibilityObserved = 'true';

    if (!('IntersectionObserver' in window)) {
      root.dataset.ctmInViewport = 'true';
      applySectionVisibility(root);
      return;
    }

    if (!visibilityObserver) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.dataset.ctmInViewport = entry.isIntersecting ? 'true' : 'false';
          applySectionVisibility(entry.target);
        });
      }, { rootMargin: '220px 0px', threshold: 0 });
    }

    visibilityObserver.observe(root);
  }

  function initCtmTestimonials(root) {
    if (!root) return;
    prepareCards(root);
    observeSectionVisibility(root);

    if (root.dataset.ctmLightboxInitialized === 'true') return;
    root.dataset.ctmLightboxInitialized = 'true';

    var lb = root.querySelector('.ctm-lightbox');
    var lbImg = root.querySelector('.ctm-lightbox__img');
    var lbCap = root.querySelector('.ctm-lightbox__caption');
    var lbClose = root.querySelector('.ctm-lightbox__close');

    if (!lb || !lbImg || !lbCap || !lbClose) return;

    function openLightbox(src, alt, caption) {
      lbImg.src = src;
      lbImg.alt = alt || '';
      lbCap.textContent = caption || '';
      lbCap.style.display = caption ? '' : 'none';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';

      window.setTimeout(function () {
        lbImg.removeAttribute('src');
      }, 320);
    }

    lb.addEventListener('click', function (event) {
      if (event.target === lb) closeLightbox();
    });

    lbClose.addEventListener('click', closeLightbox);

    root.querySelectorAll('.ctm__photo-card').forEach(function (card) {
      var img = card.querySelector('img');
      if (!img) return;

      var nameEl = card.querySelector('.ctm__photo-name');
      var detailEl = card.querySelector('.ctm__photo-detail');
      var caption = nameEl ? nameEl.textContent + (detailEl ? ' - ' + detailEl.textContent : '') : '';

      card.addEventListener('click', function () {
        openLightbox(img.src, img.alt, caption);
      });
    });
  }

  function initAllCtmTestimonials() {
    document.querySelectorAll('[data-ctm-section]').forEach(initCtmTestimonials);
  }

  document.addEventListener('mouseover', function (event) {
    var card = getCard(event.target);
    if (card) loadCardMedia(card);
  });

  document.addEventListener('focusin', function (event) {
    var card = getCard(event.target);
    if (card) loadCardMedia(card);
  });

  document.addEventListener('click', function (event) {
    var card = getCard(event.target);

    if (!isMobileTestimonials()) {
      if (card) loadCardMedia(card);
      return;
    }

    if (card) {
      setExpanded(getSection(card), true);
      return;
    }

    closeAllCards();
  });

  document.addEventListener('keydown', function (event) {
    var card = getCard(event.target);

    if (event.key === 'Escape') {
      closeAllCards();
      return;
    }

    if (!isMobileTestimonials() || !card) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    setExpanded(getSection(card), true);
  });

  function handleViewportChange() {
    if (!isMobileTestimonials()) {
      closeAllCards();
    }

    initAllCtmTestimonials();
  }

  window.addEventListener('resize', handleViewportChange);
  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-ctm-section]').forEach(applySectionVisibility);
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', handleViewportChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(handleViewportChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCtmTestimonials);
  } else {
    initAllCtmTestimonials();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCtmTestimonials(event.target.querySelector('[data-ctm-section]'));
  });
})();